<template>
  <Level
    v-if="detail?.user_id && userLevel && !detail.is_expired"
    :userLevel="userLevel"
    :icon="icon"
  ></Level>
  <div v-else-if="detail?.is_expired" class="level-over-time">
    <a-popover>
      <template #content>{{ $t('zhang-hao-yi-guo-qi') }}</template>
      {{ userLevel?.name }}
    </a-popover>
  </div>
</template>

<script lang="ts" setup>
import Level from './level.vue';
import { USER_LEVEL } from '@/constants';
import type { LoginInfo } from '~/api/interface/auth';

const props = withDefaults(
  defineProps<{
    icon?: boolean;
    data?: LoginInfo;
  }>(),
  {
    icon: true,
  },
);

const userInfo = useUserInfo();

const detail = computed(() => (props.data?.user_id ? props.data : userInfo.value));

const userLevel = computed(() =>
  props.data?.user_id
    ? USER_LEVEL()[props.data?.rights_type]
    : userInfo?.value?.rights_type && USER_LEVEL()[userInfo.value.rights_type],
);
</script>

<style lang="scss" scoped>
.level-over-time {
  @apply rounded-[8px] flex-y-center justify-center px-[5px] text-[12px] min-w-[70px];
  background-color: #dde2ff !important;
  color: #121926 !important;
  font-weight: normal !important;
}
</style>
